.e5{background:var(--palette-white);}